import { createApi } from "@reduxjs/toolkit/query/react";
import { DebtorData, DebtorFields, DebtorFilter } from "features/debtor/types/debtor";
import { baseAppQuery } from "shared/api/baseQuery";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";

const ENDPOINT = "/debtor";
const debtorsApi: any = createApi({
  reducerPath: "debtorsApi",
  baseQuery: baseAppQuery,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  tagTypes: ["debtors"],
  endpoints: (builder) => ({
    getDebtorList: builder.query<DebtorData, DebtorFilter>({
      query: (filter) => {
        const queryParams = new URLSearchParams();
        if (filter) {
          queryParams.set("page", filter.pageNumber.toString());
          queryParams.set("size", filter.pageSize.toString());
          if (filter.bin) queryParams.set("bin", filter.bin);
          if (filter.debtorName) {
            queryParams.set("debtorName", filter.debtorName);
          }
          if (filter.debtorClassId) {
            queryParams.set("debtorClassId", filter.debtorClassId);
          }
        }
        return `${ENDPOINT}/fetch-all?${queryParams}`;
      },
      providesTags: ["debtors"],
    }),
    getDebtorById: builder.query<DebtorData, string>({
      query: (id) => `${ENDPOINT}/${id}`,
      providesTags: ["debtors"],
    }),
    addDebtor: builder.mutation<DebtorData, DebtorFields>({
      query: (data) => ({
        url: ENDPOINT,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["debtors"],
      onQueryStarted: snackbarOnQueryStarted({
        successMessage:"successFormAlert",
        errorMessage:"errorFormAlert",
      })
    }),
    updateDebtor: builder.mutation<DebtorData, DebtorFields>({
      query: (data) => ({
        url: ENDPOINT,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["debtors"],
      onQueryStarted: snackbarOnQueryStarted({
        successMessage:"successFormAlert",
        errorMessage:"errorFormAlert",
      })
    }),
  }),
});

export const {
  useGetDebtorListQuery,
  useGetDebtorByIdQuery,
  useAddDebtorMutation,
  useUpdateDebtorMutation,
} = debtorsApi;
export default debtorsApi;
